import { MuiDrawer } from "./MuiDrawer";
import { MuiTypography } from "./MuiTypography";
import { Stepper } from "./MuiStepConnector";
import { MuiButton } from "./MuiButton";
import { MuiIcon } from "./MuiIcon";

const overrides = {
  ...MuiDrawer,
  ...MuiTypography,
  ...Stepper,
  ...MuiButton,
  ...MuiIcon,
};
export default overrides;
